import { z } from "zod"

export const betterDocMedicSelectionSchema = z
  .object({
    selectionKey: z.string().min(1, { error: "admin.betterDoc.medicSelectionDialog.medicRequired" }),
    startDate: z.date({ error: "admin.betterDoc.medicSelectionDialog.startDateRequired" }),
    endDate: z.date({ error: "admin.betterDoc.medicSelectionDialog.endDateRequired" }),
  })
  .refine(({ startDate, endDate }) => endDate >= startDate, {
    message: "admin.betterDoc.medicSelectionDialog.endBeforeStart",
    path: ["endDate"],
  })

export type BetterDocMedicSelectionSchema = z.infer<typeof betterDocMedicSelectionSchema>
